import { useDataChange } from 'Simple/Data.js'
import debounce from 'lodash/debounce.js'

/** @type {import('Simple/types.js').useDataOnChange} */
export default function useDataOnChange(props, data) {
  let change = useDataChange({
    context: 'tab',
    viewPath: props.viewPath,
  })

  return debounce(async function onChange(next, ...args) {
    if (!next) return

    change(inext => {
      inext.appointment_overlay.patient_id = next.patient_id
      inext.appointment_overlay.is_external_patient_id =
        next.is_external_patient_id
      inext.appointment_overlay.appointment_id = next.appointment_id
      inext.appointment_overlay.is_external_appointment_id =
        next.is_external_appointment_id
      inext.appointment_overlay.treatment_id = next.treatment_id
      inext.appointment_overlay.is_external_treatment_id =
        next.is_external_treatment_id
      inext.appointment_overlay.note = next.note
      inext.appointment_overlay.appointment_type_id = next.appointment_type_id
      inext.appointment_overlay.appointment_type_name =
        next.appointment_type_name
      inext.appointment_overlay.duration = next.duration
      inext.appointment_overlay.patient_new = next.patient_new
      inext.appointment_overlay.patient_option = next.patient_option
    })
  }, 250)
}
